import { TableHeader } from "@/models";

export const suggestedRateHeaders: TableHeader[] = [
  {
    text: "Unit Type",
    value: "unitType"
  },
  {
    text: "Unit Size",
    value: "unitSize"
  },
  {
    text: "Current Rate",
    value: "currentRate"
  },
  {
    text: "Suggested Rate",
    value: "suggestedPrice"
  },
  {
    text: "Avg IPR",
    value: "iprAvg"
  },
  {
    text: "Floor",
    value: "floor"
  },
  {
    text: "Units",
    value: "totalUnit"
  },
  {
    text: "Vacant",
    value: "totalVacant"
  },
  {
    text: "Ins",
    value: "moveIns"
  },
  {
    text: "Outs",
    value: "moveOuts"
  },
  {
    text: "Net",
    value: "netMoveIns"
  },
  {
    text: "Occ. %",
    value: "occupancy"
  },
  {
    text: "Days Same",
    value: "daySame"
  },
  {
    text: "Rule Applied",
    value: "ruleApplied"
  },
  {
    text: "Outcome Applied",
    value: "outcomeApplied"
  }
];
